module.exports = __webpack_public_path__ + "static/media/0.beginning.a2f6a088.mp4";